import React, {Fragment} from 'react';
import {Helmet} from 'react-helmet';

export default (props) => {
    const {
        sys,
        systemData: {hostname, humanReadableName, siteName},
    } = props;

    const brandName = humanReadableName.split('.')[0] || humanReadableName;
    const logoUrl = `https://csvcus.homeaway.com/rsrcs/cdn-logos/3.4.0/bce/moniker/${siteName}/logo-bceheader.png`;
    const renderedItemList = props.featuredArticles.map((article, index) => {
        return `
        {
            "@type": "ListItem",
            "position": ${index + 1},
            "url": "${props.categoryUrl}/${article.slug}"
        }
        `;
    });
    return (
        <Fragment>
            <Helmet>
                <script type="application/ld+json">
                    {`
                {
                    "@context": "http://schema.org",
                    "@type": "ItemList",
                    "ItemListElement": [
                        ${renderedItemList}
                    ]
                }
                `}
                </script>
            </Helmet>
            <meta itemProp="genre" content="travel" />
            <div
                itemProp="publisher"
                itemScope
                itemType="https://schema.org/Organization"
            >
                <meta itemProp="name" content={brandName} />
                <div
                    itemProp="logo"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                >
                    <meta itemProp="url" content={logoUrl} />
                    <meta itemProp="width" content="125" />
                    <meta itemProp="height" content="40" />
                </div>
                <link itemProp="sameAs" href={`https://${hostname}`} />
            </div>
            <span
                itemProp="author"
                itemScope
                itemType="http://schema.org/Organization"
            >
                <meta itemProp="name" content={brandName} />
            </span>
            <meta itemProp="datePublished" content={sys.firstPublishedAt} />
            <meta itemProp="dateModified" content={sys.publishedAt} />
        </Fragment>
    );
};
